var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.5 70.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 47.8c-.5-1.3-1-2.5-1.5-3.8-.1-.2-.3-.3-.5-.3h-5c-1 .1-1.9-.6-2.2-1.5-.1-.3-.1-.5-.1-.8V29c-.1-1.1.8-2.1 1.9-2.2h5.3c.3 0 .5-.1.6-.4.5-1.2.9-2.4 1.4-3.7l-2.6-2.6L7 19c-.9-.8-1-2.1-.2-3l.2-.2c1.7-1.7 3.4-3.4 5.1-5l3.6-3.6c.7-.9 2-1.1 3-.4.1.1.2.2.3.4 1.2 1.1 2.3 2.3 3.4 3.4.2.2.5.3.7.1 1.1-.5 2.2-.9 3.3-1.3.2-.1.4-.3.4-.6v-5c-.1-1.2.7-2.2 1.9-2.4h12.6c1.2-.1 2.2.8 2.3 1.9v5.3c0 .3.1.6.4.6 1.1.4 2.1.8 3.2 1.3.3.2.6.1.8-.1 1.1-1.2 2.3-2.3 3.4-3.4.7-.9 2-1.1 3-.3l.3.3 8.7 8.7c.9.8 1 2.1.3 3l-.3.3c-1.2 1.1-2.3 2.3-3.5 3.4-.2.2-.3.5-.1.7.5 1.1.9 2.2 1.4 3.3.1.2.3.4.5.4h5c1.2-.1 2.2.8 2.3 2v12.7c0 1.2-.9 2.2-2.1 2.2h-5.1c-.3-.1-.6.1-.6.4-.4 1.1-.9 2.2-1.3 3.2-.2.2-.1.5.1.7l3.4 3.4c1 .7 1.1 2.1.4 3-.1.2-.3.3-.4.4l-8.5 8.5c-.7.9-2.1 1.1-3 .4-.2-.1-.3-.3-.4-.4-1.1-1.1-2.3-2.2-3.4-3.4-.2-.2-.5-.3-.8-.2-1.2.5-2.3 1-3.6 1.5v5.4c0 1.2-.9 2.2-2 2.2q0 0 0 0H29.3c-.4 0-.8-.1-1.1-.2-.8-.3-1.3-1.2-1.3-2.1v-5c0-.3-.2-.6-.4-.6-1.1-.4-2.1-.8-3.2-1.3-.3-.2-.6-.1-.8.2l-3.4 3.4c-.7.9-2.1 1.1-3 .4-.1-.1-.3-.2-.4-.4l-8.5-8.5c-.9-.7-1.1-2.1-.3-3l.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3 35.3c0 6.1-5 11.1-11.1 11s-11.1-5-11-11.1c0-6.1 5-11 11-11 6.2 0 11.1 5 11.1 11.1q0 0 0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.335799bb4df881b2c907979abe90f1a1.svg";
export { ForwardRef as ReactComponent };